<template>
    <div class="f-topic-edit">
        <div class="f-topic-edit-route">
            <router-link class="f-topic-edit-route-hover" to="/">首页</router-link>
            <span class="f-topic-edit-route-arrow">></span>
            <span class="f-topic-edit-route-hover">发帖页</span>
        </div>

        <div class="f-topic-edit-wrapper">
            <div class="f-topic-edit-title">我要发帖</div>

            <div class="f-topic-edit-content"
                v-if="Object.keys(pageConfig).length">

                <div class="f-topic-edit-content-board">
                    <span class="f-topic-edit-content-board-label">发帖板块</span>
                    <div class="f-topic-edit-content-tags-tags">
                        <span v-for="(item, index) in extConfig"
                            @click="changeTab(item.boardInfo.id, index)"
                            :key="item.boardInfo.id"
                            :class="{'f-topic-edit-content-board-name': true,
                                'f-topic-edit-content-board-name-active': item.boardInfo.id === activeTab}">
                            {{item.boardInfo.name}}
                        </span>
                    </div>
                </div>

                <div class="f-topic-edit-content-tags"
                    v-if="extConfig[activeTabIndex] && extConfig[activeTabIndex].tagInfo && extConfig[activeTabIndex].tagInfo.length">
                    <span class="f-topic-edit-content-tags-label">业务类型</span>
                    <div class="f-topic-edit-content-tags-tags">
                        <span v-for="(item, index) in extConfig[activeTabIndex].tagInfo"
                            :key="item.id"
                            @click="changeTag(item.id, index)"
                            :class="{'f-topic-edit-content-tags-name': true,
                                'f-topic-edit-content-tags-name-active': item.id === activeTag}">
                            {{item.name}}
                            <span v-if="item.ext.tip"
                                class="f-topic-edit-content-tags-tip">{{item.ext.tip}}</span>
                        </span>
                    </div>
                </div>

                <render-component :form-config="titleConfig"></render-component>

                <div class="f-topic-edit-content-tags"
                    v-if="showTags">
                    <span class="f-topic-edit-content-tags-label">帖子标签</span>
                    <div class="f-topic-edit-content-tags-tags">
                        <el-tag
                            :key="tag"
                            v-for="tag in dynamicTags"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 帖子标签</el-button>

                    </div>
                </div>
                <div v-if="extConfig[activeTabIndex] && extConfig[activeTabIndex].tagInfo && extConfig[activeTabIndex].tagInfo.length
                    && Object.keys(extConfig[activeTabIndex].tagInfo[activeTagIndex].ext).length">
                    <div v-for="ext in extConfig[activeTabIndex].tagInfo[activeTagIndex].ext.extBeanConfig"
                        :key="ext.id">
                        <render-component
                            v-if="isRender(ext)"
                            :form-config="pageConfig[ext.template]"
                            :form-name="ext.template"
                            :editor-place-holder="ext.placeholder"
                            @changeEditPlaceholder="changeEditPlaceholder">
                        </render-component>
                    </div>
                </div>

                <div class="f-topic-edit-content-editor">
                    <span class="f-topic-edit-content-editor-label">
                        <span class="f-topic-edit-content-editor-label-required">*</span>
                        <span>详细描述</span>
                    </span>
                    <editor-component ref="childEditor"
                        style="width: 905px; display: inline-block;"
                        :editorid="'topicEditor'"
                        @change="notChangeEditor">
                    </editor-component>
                </div>

                <veui-button class="f-topic-edit-content-btn"
                    :loading="submitLoading"
                    @click="submitTopic">发布帖子</veui-button>
            </div>

        </div>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/views/edit-topic/edit-module.less';
</style>

<script>
import RenderComponent from './components/RenderComponent.vue';
import Editor from '../components/tinyEditor';
import {Button} from 'veui';
import {mapState, mapActions} from 'vuex';
import {debounce} from '@/utils/debounceThrottle.js';
import {Tip} from '@/utils/errorCode';

export default {
    components: {
        'render-component': RenderComponent,
        'editor-component': Editor,
        'veui-button': Button
    },
    data() {
        return {
            errorImg: this.$store.state.home.errorImg,
            submitLoading: false,
            showTags: false,
            inputVisible: false,
            inputValue: ''
        };
    },
    computed: {
        ...mapState({
            initPlaceholder: state => state.editTopic.initPlaceholder,
            pageConfig: state => state.editTopic.pageConfig,
            extConfig: state => state.editTopic.extConfig,
            titleConfig: state => state.editTopic.titleConfig,
            dynamicTags: state => state.editTopic.dynamicTags,
            isInputSthing: state => state.editTopic.isInputSthing,
            hasNull: state => state.editTopic.hasNull,
            activeTab: state => state.editTopic.activeTab,
            activeTabIndex: state => state.editTopic.activeTabIndex,
            activeTag: state => state.editTopic.activeTag,
            activeTagIndex: state => state.editTopic.activeTagIndex
        })
    },
    mounted() {
        this.$store.state.editTopic.dynamicTags = [];
        let params = {
            routeName: this.$route.name
        };
        let id = this.$route.params.id;
        let idx = id - 1;
        switch (this.$route.name) {
            case 'editIssue':
                params.type = 3;
                params.id = this.$route.params.topicid;
                break;
            case 'editTopic':
                params.type = 1;
                params.id = this.$route.params.topicid;
                break;
            case 'addTopic':
            default:
                if (Object.keys(this.$route.query).length > 0) {
                    Object.assign(params, this.$route.query);
                }
                break;
        }
        this.$store.dispatch('init', params)
            .then(() => {
                // 设置默认问题类型
                if (params.optionids) {
                    try {
                        this.pageConfig.suggestTypes.defaultValue = JSON.parse(params.optionids);
                    }
                    catch (e) {
                        console.warn(e);
                    }
                }

                let placeHolder = this.initPlaceholder;
                if (placeHolder.length > 0) {
                    this.$nextTick(() => {
                        this.$refs.childEditor.setContent(placeHolder);
                    });
                    this.showTags = this.activeTab === 4 ? true : false;
                    if (this.$route.params.id) {
                        this.changeTab(id, idx);
                    }
                }
                if(params.title) {
                    this.$store.commit('setInitTitle', params.title);
                }
            })
            .catch(errmsg => {
                if (errmsg === Tip.notLogin) {
                    this.$store.dispatch('navToPassport');
                }
                else {
                    this.$router.replace('/');
                }
            });
    },

    destroyed() {
        this.$store.commit('clearPageData');
        // 页面销毁同时，移除昊天镜蒙层
        this.$store.dispatch('removeMkdMask');
    },
    watch: {
        $route(to, from) {
            // 统计pv
            _hmt.push(['_trackPageview', '/forum' + to.path]);
        }
    },
    methods: {
        ...mapActions(['notChangeEditor']),
        isRender(ext) {
            if (!ext.displayConditions) {
                return true;
            }
            for (let conditionItem of ext.displayConditions) {
                if (conditionItem.conditionType === '==='
                        && this.pageConfig[conditionItem.sourseId].defaultValue !== conditionItem.value) {
                    return false;
                }
                if (conditionItem.conditionType === '!=='
                        && this.pageConfig[conditionItem.sourseId].defaultValue === conditionItem.value) {
                    return false;
                }
            }
            return true;
        },

        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            this.$store.dispatch('setTags', this.dynamicTags);
        },
        changeTab(id, idx) {
            this.showTags = id === 4 ? true : false;
            this.$store.dispatch('chooseTab', {id, idx});
            this.changeEditPlaceholder(this.initPlaceholder);
        },
        changeTag(id, idx) {
            this.$store.dispatch('chooseTag', {id, idx});
            this.changeEditPlaceholder(this.initPlaceholder);
        },
        changeEditPlaceholder(placeHolder) {
            if (!this.isInputSthing) {
                this.$nextTick(() => {
                    this.$refs.childEditor.setContent(placeHolder);
                });
            }
        },
        submitTopic: debounce(function () {
            this.$route.params.topicid ? _hmt.push(['_trackEvent', 'operation', '编辑页发帖按钮点击'])
                : _hmt.push(['_trackEvent', 'operation', '发帖页发帖按钮点击']);

            let content = this.$refs.childEditor.getContent();
            let pureText = this.$refs.childEditor.getText();

            this.$store.dispatch('checkForm', {content, pureText});
            if (!this.hasNull) {
                this.submitLoading = true;
                this.$store.dispatch('submit')
                    .then(data => {
                        this.submitLoading = false;
                        if (data) {
                            setTimeout(() => {
                                switch (data.topicType) {
                                    case 3:
                                        this.$router.push({name: 'issueContent', params: {issueid: data.issueId}});
                                        break;
                                    case 1:
                                    default:
                                        this.$router.push({name: 'topicContent', params: {topicid: data.topicId}});
                                }
                            }, 500);
                        }
                    }).catch(() => this.submitLoading = false);
            }
        })
    }
};
</script>